module.exports = __webpack_public_path__ + "af5c9eaa668cdeb6e10fc15e3b8369c7.png";